import ActiveConversations from "../../views/messaging/ActiveConversations";

export default [
    {
        path: '/messaggistica',
        name: 'messaging',
        component: ActiveConversations,
        meta: {requiresAuth: true, showNav: true}
    }
]
